import { useMediaQuery, useTheme } from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import { CheckboxList } from "./CheckBoxList";
import { CheckboxItem } from "./CheckBoxListItem";

export type FilterData = {
    timeOfDay: string[];
    dayOfWeek: string[];
    topic: string[];
    status: string[];
};

export type FilterDataOption = {
    label: string;
    value: any;
    type?: string;
};

type FilterProps = {
    options: CheckboxItem[];
    selected: string[];
    onUpdate: (updatedFilters: string[]) => void;
    defaultOptionText: string;
    title: string;
    shortenLabelWhenMultipleSelected?: string; // Enter a word here, eg: "topics" will display "3 topics" if the number of selected filters is > 1
    hideEmptyOption?: boolean;
};

export const Filter = (props: FilterProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const {
        options,
        selected,
        onUpdate,
        defaultOptionText,
        shortenLabelWhenMultipleSelected,
        title,
        hideEmptyOption,
    } = props;
    const [openFilter, setOpenFilter] = useState(false);

    const handleClickOpen = () => {
        setOpenFilter(true);
    };

    const handleClose = () => {
        setOpenFilter(false);
    };

    const renderDialogContent = () => {
        return (
            <CheckboxList
                emptyLabel={hideEmptyOption ? undefined : defaultOptionText}
                items={options}
                selectedValues={selected}
                onChange={onUpdate}
            />
        );
    };

    const getLabelForValue = (value: string) => {
        const selectedOption = options.find((x) => x.value === value);
        return selectedOption?.label || value;
    };

    const joinWithCommasAndOr = (words: string[]) => {
        return _.compact([words.slice(0, -1).join(", "), words.slice(-1)[0]]).join(" or ");
    };

    const getLabel = () => {
        if (selected.length < 1) {
            return defaultOptionText;
        } else if (selected.length === 1) {
            return getLabelForValue(selected[0]);
        } else {
            if (shortenLabelWhenMultipleSelected) {
                return `${selected.length} ${shortenLabelWhenMultipleSelected}`;
            } else {
                const labels = selected.map(getLabelForValue);
                return joinWithCommasAndOr(labels);
            }
        }
    };

    return <>{renderDialogContent()}</>;
};
